// extracted by mini-css-extract-plugin
module.exports = {"transition":"App_transition__3JKdo","bodyLeft":"App_bodyLeft__2CsFR","bodyRight":"App_bodyRight__3V7Xh","bodyFixed":"App_bodyFixed__ncCM_","appContainer":"App_appContainer__juug1"};